<table class="table table-striped table-responsive-lg" *ngIf="visitors.length > 0">
  <thead>
  <tr>
    <th scope="col" class="text-center">#</th>
    <th scope="col" class="text-center">First Name</th>
    <th scope="col" class="text-center">Last Name</th>
    <th scope="col" class="text-center">Phone</th>
    <th scope="col" class="text-center">Email</th>
    <th scope="col" class="text-center">Order Status</th>
    <th scope="col" class="text-center">Order Start</th>
    <th scope="col" class="text-center">Order End</th>
    <th scope="col" class="text-center">Work places</th>
<!--    <th scope="col" class="text-center">Code</th>-->
    <th scope="col" class="text-center">QR</th>
    <th scope="col" class="text-center"></th>
    <th scope="col" class="text-center"></th>
    <th scope="col" class="text-center"></th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let visitor of visitors">
    <th scope="row">{{visitor.id}}</th>
    <td class="text-center">{{visitor.firstname}}</td>
    <td class="text-center">{{visitor.lastname}}</td>
    <td class="text-center">{{visitor.phone}}</td>
    <td class="text-center">{{visitor.email}}</td>
    <td class="text-center">{{visitor.order.status}}</td>
    <td class="text-center">{{visitor.order.start | date:'dd.MM.yy HH:mm' }}</td>
    <td class="text-center">{{visitor.order.end | date:'dd.MM.yy HH:mm' }}</td>
    <td class="text-center">{{visitor.order.workPlaces}}</td>
    <td class="text-center">
      <div *ngIf="visitor.order.status != 'CANCELLED' && visitor.order.status != 'FINISHED'" class="mx-auto text-center">
        <ng-container *ngFor="let door of visitor.order.doors">
          <label *ngIf="door.name=='Main Entrance'">{{door.code}}</label>
        </ng-container>
        <ng-container>
          <a [routerLink]="['/qr/' + visitor.order.qrToken]" class="btn btn-sm qr-button">QR</a>
        </ng-container>
      </div>
    </td>
    <td class="text-center">
      <div *ngIf="visitor.order.status != 'CANCELLED' && visitor.order.status != 'STARTED' && visitor.order.status != 'FINISHED'" class="mx-auto text-center">
        <a (click)="orderCancel(visitor.id)" class="btn btn-sm cancel-button">Cancel</a>
      </div>
    </td>
  </tr>
  </tbody>
</table>
<div *ngIf="visitors.length == 0">
  <strong>You don't have visitors yet.</strong>
</div>

